import React, { useEffect, useState } from 'react';
import Spinner from '../Global/Spinner';
import client from '../../api/client';
import Table from '../../layout/admin/Table';
import TableDynamic from '../Global/TableDynamic';
export default function CustomerList() {
	const [customers, setCustomers] = useState([]);
	const [loading, setLoading] = useState(false);
	const getClients = async () => {
		try {
			setLoading(true);
			console.log('inside get clients');
			const { data } = await client.get('/customer');
			console.log({ data });
			if (data) setCustomers(data.customers);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			return console.error(err);
		}
	};
	useEffect(() => {
		getClients();
	}, []);
	if (loading) return <Spinner />;
	return (
		<div className=''>
			<TableDynamic
				data={customers}
				title='Emails Collected'
			/>
		</div>
	);
}
